export const currentBranch = process.env.REACT_APP_BRANCH;
export enum TRADE_STATUS {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
}

export enum POSITION_TYPE {
  UP = "UP",
  DOWN = "DOWN",
}

export enum IDENTITY_STATUS {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
}

export enum TRANSACTION {
  TOPUP = "TOPUP",
  WITHDRAW = "WITHDRAW",
}

export enum DOCUMENT_TYPE {
  ID_CARD = "idCard",
  DRIVING_LICENCE = "drivingLicence",
  PASSPORT = "passport",
  RESIDENCE_PERMIT = "residencePermit",
}
